import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./home/Home";

import Fruits from "./games/fruits/Fruits";
import VendingMachine from "./vending-machine/VendingMachine";
import VendingMachineHistory from "./vending-machine/history/VendingMachineHistory";
import VendingMachineDraw from "./vending-machine/draw/VendingMachineDraw";
import Boosting from "./vending-machine/boosting/Boosting";
import Referral from "./tycoon/referral";

import WebLogin from "./user/login";
import NaverLoginCallBack from "./user/naver/loginCallBack";
import KakaoLoginCallBack from "./user/kakao/loginCallBack";
import Withdraw from "./user/withdraw";
import Guerrilla from "./rewards/Guerrilla";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/games/fruits",
      element: <Fruits />,
    },
    {
      path: "/vending-machine",
      element: <VendingMachine />,
    },
    {
      path: "/vending-machine/history",
      element: <VendingMachineHistory />,
    },
    {
      path: "/vending-machine/draw/*",
      element: <VendingMachineDraw />,
    },
    {
      path: "/vending-machine/boosting",
      element: <Boosting />,
    },
    {
      path: "/tycoon/referral",
      element: <Referral />,
    },
    {
      path: "/user/login",
      element: <WebLogin />,
    },
    {
      path: "/user/naver/callback",
      element: <NaverLoginCallBack />,
    },
    {
      path: "/user/kakao/callback",
      element: <KakaoLoginCallBack />,
    },
    {
      path: "/user/withdraw",
      element: <Withdraw />,
    },
    {
      path: "/rewards/guerrilla",
      element: <Guerrilla />,
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;
